var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("el-card", { staticClass: "employees-card-bottom" }, [
        _c("div", { staticClass: "auth acea-row row-between-wrapper" }, [
          _c("div", { staticClass: "acea-row row-middle" }, [
            _c("img", {
              staticClass: "img",
              attrs: {
                alt: "",
                src: require("../../../../assets/images/deng.png"),
              },
            }),
            _vm._v(" "),
            _vm.status === -1 || _vm.status === -9
              ? _c("div", { staticClass: "text" }, [
                  _c("div", [
                    _vm._v("体验时间剩余 " + _vm._s(_vm.dayNum) + "天"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "code" }, [
                    _vm._v(
                      "到期后移动端将不能正常使用，如果您对我们的系统满意，请支持正版！"
                    ),
                  ]),
                ])
              : _vm.status === 2
              ? _c("div", { staticClass: "text" }, [
                  _c("div", [
                    _vm._v("体验时间剩余 " + _vm._s(_vm.dayNum) + "天"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "code red" }, [
                    _vm._v("审核未通过"),
                  ]),
                ])
              : _vm.status === 1
              ? _c("div", { staticClass: "text" }, [
                  _c("div", [_vm._v("商业授权")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "code" }, [
                    _vm._v("授权码：" + _vm._s(_vm.authCode || "--")),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "code block" }, [
                    _vm._v("\n            授权时间："),
                    _vm.authTime !== 99999
                      ? _c("span", [
                          _vm._v(
                            "\n              剩余" +
                              _vm._s(_vm.authTime || "0") +
                              " 天\n              "
                          ),
                          _vm.authTime <= 15
                            ? _c("span", { staticClass: "tips" }, [
                                _vm._v("(授权到期后，系统将无法使用)"),
                              ])
                            : _vm._e(),
                        ])
                      : _c("span", [_vm._v("永久")]),
                  ]),
                ])
              : _vm.status === 0
              ? _c("div", { staticClass: "text" }, [
                  _c("div", [
                    _vm._v("体验时间剩余 " + _vm._s(_vm.dayNum || "--") + "天"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "code blue" }, [
                    _vm._v("授权申请已提交，请等待审核"),
                  ]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.toCrmeb()
                      },
                    },
                  },
                  [_vm._v("进入官网")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.payment("oa")
                      },
                    },
                  },
                  [_vm._v("申请授权 ")]
                ),
              ],
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.isTemplate,
            "z-index": 1,
            center: "",
            title: "商业授权",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isTemplate = $event
            },
            "on-cancel": _vm.cancel,
          },
        },
        [
          _c("iframe", {
            attrs: {
              src: _vm.iframeUrl,
              frameborder: "0",
              height: "550",
              width: "100%",
            },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }